/**
 * Presentation constants and pure style helpers for the Seam Crossing Rush
 * panel: the round and tick cadence, and the witness lookup. None of this
 * decides the "does it cross" verdict — that
 * lives in algorithms/seamCrossingRush. These are only the
 * constructable scaffolding the panel and its board render.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */
import type {
  WitnessComponent,
  WitnessId,
} from "../algorithms/seamCrossingRush.js";
export const ROUND_SECONDS = 45;
export const TICK_MS = 850;
export function componentById(
  palette: readonly WitnessComponent[],
  id: WitnessId,
): WitnessComponent | null {
  return palette.find((c) => c.id === id) ?? null;
}
